const getProjectByFn = (projects, fn) => {
    for (var idx = 0; idx < projects.length; idx++) {
        const p = projects[idx];
        if (p && fn(p)) {
            return [p, idx];
        }
    }
    return [undefined, undefined];
};

const getProjectById = (projects, id) => {
    return getProjectByFn(projects, p => {
        return p.id && p.id === id;
    });
};

const store = {
    namespaced: true,

    state: {
        projects: [],
        selected: undefined
    },
    getters: {
        projectById: state => id => {
            return getProjectById(state.projects, id)[0];
        },

        selectedProject: state => {
            const selIdx = state.selected;
            if (selIdx !== undefined) {
                return state.projects[selIdx];
            }
            return undefined;
        },

        list: state => {
            return state.projects;
        }
    },
    mutations: {
        setSelected(state, id) {
            const [prj, idx] = getProjectById(state.projects, id);
            if (prj !== undefined) {
                if (state.selected !== undefined) {
                    const prevPrj = state.projects[state.selected];
                    if (prevPrj) {
                        prevPrj.isSelected = false;
                    }
                }
                state.selected = idx;
                prj.isSelected = true;
            } else {
                console.log(`project with id ${id} do not exists`);
            }
        },
        add(state, prj) {
            if (!prj || !prj.id) {
                console.log("project does not have a valid id", prj);
            } else {
                if (getProjectById(state.projects, prj.id)[0] === undefined) {
                    // add projects sorted by creation date.
                    const curDate = new Date(prj.project.date).getTime();
                    let inserted = false;
                    for (let idx = 0; idx < state.projects.length; idx++) {
                        const p = state.projects[idx];
                        const p_date = new Date(p.project.date).getTime();
                        if (p_date < curDate) {
                            state.projects.splice(
                                idx,
                                0,
                                JSON.parse(JSON.stringify(prj))
                            );
                            inserted = true;
                            break;
                        }
                    }
                    if (!inserted) {
                        state.projects.push(JSON.parse(JSON.stringify(prj)));
                    }
                }
            }
        },
        del(state, id) {
            if (!id) {
                console.log("Invalid id", id);
            } else {
                const [prj, idx] = getProjectById(state.projects, id);
                if (idx >= 0) {
                    if (prj.selected || state.selected == idx) {
                        state.selected = undefined;
                    }
                    state.projects.splice(idx, 1);
                }
            }
        },
        change(state, payload) {
            const id = payload.id;
            const prj = payload.prj;
            if (!id) {
                console.log("Invalid id", id);
            } else if (!prj || !prj.id) {
                console.log("project does not have a valid id", prj);
            } else {
                const [oldPrj, idx] = getProjectById(state.projects, id);
                if (oldPrj == undefined) {
                    console.log(`project with id ${id} has not been found`);
                } else {
                    if (prj.id !== oldPrj.id) {
                        console.log(
                            `existing project with id ${oldPrj.id} does not match the new id ${prj.id}`
                        );
                    } else {
                        state.projects[idx] = prj;
                    }
                }
            }
        },
        clear(state) {
            state.selected = undefined;
            state.projects.length = 0;
        }
    },
    actions: {
        initStore() {},
        setSelected(context, id) {
            context.commit("setSelected", id);
        },
        add(context, prj) {
            context.commit("add", prj);
        },
        del(context, id) {
            context.commit("del", id);
        },
        change(context, payload) {
            context.commit("change", payload);
        },
        clear(context) {
            context.commit("clear");
        }
    }
};

export default store;
